import { ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from "@angular/core";
import {FormArray, FormGroup} from "@angular/forms";
import {
  JaarrapportageEntity,
  ClientEntity,
  TrialBalanceItem, Jaarrekening, Jaarrapportage, BokkzJrLogic
} from "@snelstart-ventures/fiscaal/domain-logic";
import {BokkzAlgDataService, BokkzJrDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import { SelectFormControlItem, SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { combineLatest, distinctUntilChanged, Observable, ReplaySubject, Subject, takeUntil } from "rxjs";
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SpecTrialbalanceComponent } from '../spec-trialbalance/spec-trialbalance.component';
import { SpecFormattedexplanationComponent } from '../spec-formattedexplanation/spec-formattedexplanation.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-spec-waardeveranderingen-vastgoedbeleggingen',
  templateUrl: './spec-waardeveranderingen-vastgoedbeleggingen.component.html',
  imports: [
    SharedUiFormControlsModule,
    SharedUiDetailsModule,
    SharedUiButtonModule,
    SpecTrialbalanceComponent,
    SpecFormattedexplanationComponent,
    CommonModule
  ],
  styleUrls: ['./spec-waardeveranderingen-vastgoedbeleggingen.component.scss']
})
export class SpecWaardeveranderingenVastgoedbeleggingenComponent implements OnInit,OnChanges,OnDestroy {

  @Input() public id!: string;
  @Input() selectedTabObservable!: Observable<number>;
  private selectedTabSubject = new ReplaySubject<number>(1);
  showCustomControls = true;
  private destroy$ = new Subject<void>();
  public selectedTab = 0;
  public index = 0;
  public dialogVisible = false;
  public client = {} as ClientEntity;
  public jrEntity = {} as JaarrapportageEntity;
  public isRechtspersoon = false;

  public changesValueInvestmentPropertiesFg = {} as FormGroup;
  public impairmentInvestmentPropertiesRecordedInIncomeStatementFg = {} as FormGroup;
  public impairmentInvestmentPropertiesReversalRecordedInIncomeStatementFg = {} as FormGroup;

  public changesValueInvestmentPropertiesDisclosureFg = {} as FormGroup;

  public optionsJaNee: SelectFormControlItem<boolean>[] = [
    {value: true, label: "Ja"},
    {value: false, label: "Nee"},
  ];

  public showDialog(input: number) {
    this.index = input
    this.dialogVisible = true;
  }

  constructor(
    public algDataService: BokkzAlgDataService,
    private cdRef: ChangeDetectorRef,
    private jrLogicService: BokkzJrLogic,
    public jrDataService: BokkzJrDataService) {
    this.createFormGroups();
  }

  ngOnInit(): void {
    if (this.selectedTabObservable) {
      this.selectedTabObservable
        .pipe(takeUntil(this.destroy$))
        .subscribe(tab => {
          this.selectedTabSubject.next(tab);
        });
    }

    combineLatest([
      this.selectedTabSubject.pipe(distinctUntilChanged()),
      this.jrDataService.jaarrapportageEntity
    ])
      .pipe(takeUntil(this.destroy$))
      .subscribe(([tab, jrEntity]) => {
        this.selectedTab = tab;
        this.jrEntity = jrEntity;
        this.patchData(jrEntity);
      });

    this.jrDataService.isRechtspersoon.subscribe((value) => {
      this.isRechtspersoon = value;
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedTabObservable']) {
      this.selectedTabObservable = changes['selectedTabObservable'].currentValue;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public createFormGroups() {
    this.changesValueInvestmentPropertiesFg = this.jrDataService.createFormGroupMonetaryNoDecimalsPeriodValues();
    this.impairmentInvestmentPropertiesRecordedInIncomeStatementFg = this.jrDataService.createFormGroupBalanceItem();
    this.impairmentInvestmentPropertiesReversalRecordedInIncomeStatementFg = this.jrDataService.createFormGroupBalanceItem();

    this.changesValueInvestmentPropertiesDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
  }

  private patchData(value: JaarrapportageEntity) {
    const waardeveranderingenVastgoedbeleggingen = value.rapportage?.jaarrekeningen?.at(0)?.winstEnVerliesrekening?.waardeveranderingenVastgoedbeleggingen;
    if (waardeveranderingenVastgoedbeleggingen) {
      this.changesValueInvestmentPropertiesFg.reset()

      if (waardeveranderingenVastgoedbeleggingen?.changesValueInvestmentProperties) {
        this.changesValueInvestmentPropertiesFg.patchValue(waardeveranderingenVastgoedbeleggingen.changesValueInvestmentProperties, {emitEvent: false})
      }

      const uitsplitsing = waardeveranderingenVastgoedbeleggingen.waardeveranderingenVastgoedbeleggingenUitsplitsing;
      const tekstueel = waardeveranderingenVastgoedbeleggingen.waardeveranderingenVastgoedbeleggingenTekstueel;

      if (uitsplitsing) {
        if (uitsplitsing.impairmentInvestmentPropertiesRecordedInIncomeStatement) {
          const subItem = uitsplitsing.impairmentInvestmentPropertiesRecordedInIncomeStatement;
          this.impairmentInvestmentPropertiesRecordedInIncomeStatementFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem?.trialBalanceItems!, this.impairmentInvestmentPropertiesRecordedInIncomeStatementFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing.impairmentInvestmentPropertiesReversalRecordedInIncomeStatement) {
          const subItem = uitsplitsing.impairmentInvestmentPropertiesReversalRecordedInIncomeStatement;
          this.impairmentInvestmentPropertiesReversalRecordedInIncomeStatementFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem?.trialBalanceItems!, this.impairmentInvestmentPropertiesReversalRecordedInIncomeStatementFg.get('trialBalanceItems') as FormArray)
        }
      }

      if (tekstueel) {
        if (tekstueel.changesValueInvestmentPropertiesDisclosure) {
          this.changesValueInvestmentPropertiesDisclosureFg.patchValue(tekstueel.changesValueInvestmentPropertiesDisclosure);
        }
      }
    }
  }

  updateTrialBalanceItems(lijst?: TrialBalanceItem[], formArray?: FormArray) {
    if (lijst && formArray) {
      for (let i = 0; i < lijst.length; i++) {
        if (i < formArray.length) {
          const control = formArray.at(i) as FormGroup;
          control.patchValue(lijst[i]);
        } else {
          const formGroup = this.jrDataService.createFormGroupTrialBalanceItem(lijst[i])
          formArray.push(formGroup);
        }
      }
    }
  }

  public saveForm(): void {
    this.showCustomControls = false;
    this.cdRef.detectChanges();
    setTimeout(() => {
      this.showCustomControls = true;
      this.cdRef.detectChanges();
    });

    this.changesValueInvestmentPropertiesFg.updateValueAndValidity();
    this.impairmentInvestmentPropertiesRecordedInIncomeStatementFg.updateValueAndValidity();
    this.impairmentInvestmentPropertiesReversalRecordedInIncomeStatementFg.updateValueAndValidity();

    this.changesValueInvestmentPropertiesDisclosureFg.updateValueAndValidity();

    if (this.jrEntity && this.jrEntity.rapportage && this.jrEntity.rapportage.jaarrekeningen) {
      this.jrEntity.rapportage.jaarrekeningen[0] = {
        ...this.jrEntity.rapportage.jaarrekeningen[0],
        winstEnVerliesrekening: {
          ...this.jrEntity.rapportage?.jaarrekeningen[0]?.winstEnVerliesrekening,
          waardeveranderingenVastgoedbeleggingen: {
            ...this.jrEntity.rapportage?.jaarrekeningen[0]?.winstEnVerliesrekening?.waardeveranderingenVastgoedbeleggingen,
            waardeveranderingenVastgoedbeleggingenUitsplitsing: {
              ...this.jrEntity.rapportage?.jaarrekeningen[0]?.winstEnVerliesrekening?.waardeveranderingenVastgoedbeleggingen?.waardeveranderingenVastgoedbeleggingenUitsplitsing,
              impairmentInvestmentPropertiesRecordedInIncomeStatement: this.impairmentInvestmentPropertiesRecordedInIncomeStatementFg.value,
              impairmentInvestmentPropertiesReversalRecordedInIncomeStatement: this.impairmentInvestmentPropertiesReversalRecordedInIncomeStatementFg.value,
            },
            waardeveranderingenVastgoedbeleggingenTekstueel: {
              ...this.jrEntity.rapportage?.jaarrekeningen[0]?.winstEnVerliesrekening?.waardeveranderingenVastgoedbeleggingen?.waardeveranderingenVastgoedbeleggingenTekstueel,
              changesValueInvestmentPropertiesDisclosure: this.changesValueInvestmentPropertiesDisclosureFg.value,
            }
          },
        }
      } as Jaarrekening
    }

    this.jrEntity = {
      ...this.jrEntity,
      rapportage: {
        ...this.jrEntity.rapportage,
        jaarrekeningen: [this.jrEntity.rapportage?.jaarrekeningen?.at(0)]
      }
    } as Jaarrapportage
    this.jrDataService.updateEntity(this.jrEntity);
    this.jrLogicService.getCalculation(this.jrEntity)
  }
}

